
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gallery",
      function () {
        return require("private-next-pages/gallery.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/gallery"])
      });
    }
  